/**
 * Map raw assistant error codes / strings to safe i18n keys or display text.
 * GPU_BUSY stays special-cased by callers; SYSTEM_ERROR* and unknown codes → generic.
 */
export function mapChatErrorMessage(
  raw: string | undefined,
  t: (key: string) => string,
): { isGpuBusy: boolean; body: string } {
  if (raw === 'GPU_BUSY') {
    return { isGpuBusy: true, body: t('chat.gpuBusyBody') };
  }

  if (!raw || raw.trim().length === 0) {
    return { isGpuBusy: false, body: t('chat.genericError') };
  }

  const normalized = raw.trim().toUpperCase();
  if (
    normalized === 'SYSTEM_ERROR' ||
    normalized.startsWith('SYSTEM_ERROR') ||
    normalized === 'INTERNAL_ERROR' ||
    normalized === 'UNKNOWN_ERROR'
  ) {
    return { isGpuBusy: false, body: t('chat.genericError') };
  }

  // Known user-facing i18n keys already resolved by messaging (sendFailed, timeout, …)
  if (raw.startsWith('chat.')) {
    return { isGpuBusy: false, body: t(raw) };
  }

  // Prefer not to leak raw backend dumps that look like stack / codes
  if (/^[A-Z][A-Z0-9_]{2,}$/.test(raw.trim())) {
    return { isGpuBusy: false, body: t('chat.genericError') };
  }

  // Already localized / human copy from FE
  return { isGpuBusy: false, body: raw };
}
